import React, {useEffect} from "react"

import OrderingFulfillmentDetails from "../OrderingFulfillmentDetails";

import PayeeOrderListItem from "../../components/PayeeOrderListItem"
import IconButton from "../../components/IconButton";
import ClickablePhoneNumber from "../../components/ClickablePhoneNumber";

import { shortenReference } from "../../utils/interfaceUtils";
import {timestampToDateString, addDuration, addDurations} from "../../utils/datetimeUtils"
import {alphabeticalSort, capitalizeAllWords} from "../../utils/stringUtils"
import { countCartItems} from "../../utils/cartUtils"

import {useSelector, useDispatch} from "react-redux"
import {httpFetchSaveReceipt} from "../../actions";

import {shareViaWhatsapp, copyToClipboard} from "../../utils/interactionUtils"
import { PAYEE_CATALOG_TYPE_DELIVERY, PAYEE_CATALOG_TYPE_ORDERING } from "../../constants/payeeCatalog";
import { FULFILLMENT_METHOD_DELIVERY, FULFILLMENT_METHOD_PICKUP } from "../../constants/payeeOrder";
import {PinIcon} from "../../constants/serverImages"
const PayeeOrderDetails = ({payeeOrderId="", payeeName=""}) => {
    const order = useSelector(state => state.payeeOrders.payeeOrdersById[payeeOrderId])
    let {reference, lineItemsById={}, totalXcd=0, paidByPayerName="", paidAt=0, currentStatus="", payerData={}, payeeCatalogType="", catalogMetadata={}, receiptId=""} = order || {}
    const receipt = useSelector(state => state.receipts.receiptsById[receiptId])
    const dispatch = useDispatch()
    useEffect(() => {
        if (receiptId && payeeCatalogType === PAYEE_CATALOG_TYPE_DELIVERY && Object.keys(lineItemsById).length === 0) dispatch(httpFetchSaveReceipt(receiptId))
    }, [receiptId])
    if (!order) return ""
    const {phoneNumber=""} = payerData || {}
    const {pickupAddress, deliveryAddress, prepTimes, waitTimes, fulfillmentMethod} = catalogMetadata
    const {name:pLocationName="", line1:pLine1="", line2:pLine2="", countryName:pCountryName="", city:pCity="", directions:pDirections="", contactNumber:pContactNumber=""} = pickupAddress || {}
            const {name:dLocationName="", line1:dLine1="", line2:dLine2="", countryName:dCountryName="", city:dCity="", directions:dDirections="", contactNumber:dContactNumber="", latLon:dLatLon={}} = deliveryAddress || {}
    const shortReference = shortenReference(reference)
    //modify title details based on order type
    if (receipt && payeeCatalogType === PAYEE_CATALOG_TYPE_DELIVERY && Object.keys(lineItemsById).length === 0){
        lineItemsById = receipt.lineItemsById
    }
    let orderTitleLabel = "Order from"
    let orderedLabel = "Ordered At"
    let readyByLabel = "Prepare By"
    let readyByAvg = 0
    let readyByBuffer = 0
    let fulfillmentMessage = ""
    let whatsappMessage = `Hi ${String(paidByPayerName).split(" ")[0]}, this is ${payeeName}. Your order ${shortReference} `
    let itemDetails = [
        ...Object.values(lineItemsById)
            .sort((a, b) => alphabeticalSort(a.name, b.name))
            .map(i => i ? `${i.quantity}x ${i.name}${i.hasVariants ? ` (${i.variantDetails})` : ""}` : "")
    ]
    const orderTitle = `*Order details (${countCartItems({lineItemsById})} items)*`
    let forwardedWhatsappDetails = [
        orderTitle,
        ...itemDetails
    ]   
    if (payeeCatalogType === PAYEE_CATALOG_TYPE_DELIVERY){
        orderTitleLabel = "Delivery requested by"
        orderedLabel = "Requested At"
        readyByLabel = "Deliver Before"
        whatsappMessage = `Hi ${String(paidByPayerName).split(" ")[0]}, this is ${payeeName}. Your delivery from ${pickupAddress.name} ${shortReference} `
        if (waitTimes){
            readyByAvg = addDuration(paidAt, waitTimes.avg)
            readyByBuffer = addDuration(paidAt, addDurations(waitTimes.avg, waitTimes.buffer))
        }
        forwardedWhatsappDetails = []
        if (pickupAddress && deliveryAddress){
            // const formatGoogleMapsLink = ({ lat, lon }) => lat && lon ? `https://www.google.com/maps?q=${lat},${lon}` : null;
            const formatAddressLine = (...lines) => lines.filter(Boolean).map(capitalizeAllWords).join(",\n")
            // const mapLink = formatGoogleMapsLink(dLatLon);
            forwardedWhatsappDetails = [
                `*Delivery details (${pCity} to ${dCity})*`,
                '*Pickup from:*',
                formatAddressLine(pLocationName, pLine1, pLine2, pCity, pCountryName, pContactNumber),
                "",
                ...(pDirections ? ["_Pickup Directions:_", pDirections] : []),
                "",
                '*Deliver to:*',
                formatAddressLine(dLocationName, dLine1, dLine2, dCity, dCountryName, dContactNumber || phoneNumber),
                "",
                ...(dDirections ? ["_Delivery Directions:_", dDirections] : []),
                // ...(mapLink ? ["Map: " + mapLink] : []),
            ]
            if (itemDetails.length > 0) {
                forwardedWhatsappDetails = [
                    ...forwardedWhatsappDetails,
                    "",
                    orderTitle,
                    ...itemDetails
                ]
            }
        }
    } else if (payeeCatalogType === PAYEE_CATALOG_TYPE_ORDERING && prepTimes && fulfillmentMethod){
        //handle ORDERING
        readyByAvg = addDuration(paidAt, prepTimes.avg)
        readyByBuffer = addDuration(paidAt, addDurations(prepTimes.avg, prepTimes.buffer))
        fulfillmentMessage = fulfillmentMethod === FULFILLMENT_METHOD_PICKUP ? "Pickup" :
                             fulfillmentMethod === FULFILLMENT_METHOD_DELIVERY ? `Delivery to ${capitalizeAllWords(deliveryAddress.city)}`: ""
    }

    const handleSend = () => {
        const getMessage = () => [
            `${payeeName} Order via Shopdm Pay`,
            `Ref: *${shortReference}*`,
            "",
            "*Customer details*",
            `Name: ${paidByPayerName}`,
            `Phone: ${phoneNumber}`,
            `${orderedLabel}: ${timestampToDateString(paidAt, "EEE, dd MMMM 'at' t")}`,
            `Status: ${currentStatus}`,
            "",
            ...forwardedWhatsappDetails
        ].join("\n");
    
        const message = getMessage();
        copyToClipboard(message);
        shareViaWhatsapp(message);
    };
    return (
        <div>

            <div className="margin-bottom-1em display-width-400px">
                <div className="margin-bottom-05em">
                    <div className="h1 display-flex ">
                        <span>${totalXcd} {orderTitleLabel} {paidByPayerName}</span>
                        <div className="margin-left-05em">
                            <IconButton 
                                icon="shortcut" 
                                label="send" 
                                size="small"
                                onClick={handleSend} 
                            />
                        </div>
                    </div> 
                    <div>Reference: <span className="font-weight-600">{shortReference}</span></div>
                    <div className="margin-top-05em">Name: <span className="font-weight-600">{paidByPayerName}</span></div>
                    <div className="display-flex align-items-center">
                        Phone: 
                        <ClickablePhoneNumber 
                            phoneNumber={dContactNumber || phoneNumber}
                            phoneLabel={`Call ${paidByPayerName}`}
                            whatsappLabel={`Whatsapp ${paidByPayerName}`}
                            whatsappMessage={whatsappMessage}
                        />
                    </div>
                    <div className="margin-top-05em">{orderedLabel}: <span className="font-weight-600">{timestampToDateString(paidAt, "EEE, dd MMMM 'at' t")}</span></div>
                    {fulfillmentMessage ? <div>Fulfillment: <span className="font-weight-600">{fulfillmentMessage}</span></div> : null}
                    <div className="margin-top-05em">Status: <span className="font-weight-600">{currentStatus}</span></div>
                    {
                            readyByAvg ? 
                        <div>{readyByLabel}: <span className="font-weight-600">{timestampToDateString(readyByAvg, "t")} - {timestampToDateString(readyByBuffer, "t")}</span></div>
                        :
                        null
                    }
                    
                </div>
                {
                    payeeCatalogType === PAYEE_CATALOG_TYPE_DELIVERY && pickupAddress && deliveryAddress && waitTimes && prepTimes ?
                    <React.Fragment>
                        <div className="font-weight-600 margin-top-05em">Delivery details</div>
                        <div className="margin-bottom-5px">From:</div>
                        <OrderingFulfillmentDetails 
                            location={pickupAddress}
                            waitTimes={prepTimes}
                            phoneIsActive={true}
                        />
                        <div className="margin-bottom-5px">To:</div>
                        <OrderingFulfillmentDetails 
                            location={deliveryAddress}
                            waitTimes={waitTimes}
                            fulfillmentMethod={FULFILLMENT_METHOD_DELIVERY}
                            IconImg={PinIcon}
                        />
                    </React.Fragment>
                    :
                    null
                }
                {
                    Object.keys(lineItemsById).length > 0 ?
                    <React.Fragment>
                        <div className="font-weight-600 margin-top-05em">{countCartItems({lineItemsById})} items</div>
                        <div>
                            {
                                Object.values(lineItemsById)
                                    .sort( (iA, iB) => alphabeticalSort(iA.name, iB.name))
                                    .map( i => <PayeeOrderListItem key={i.id} item={i}/>)
                            }
                        </div>
                    </React.Fragment>
                    :
                    null
                }
            </div>
        </div>
    )
}

export default PayeeOrderDetails